export default __webpack_public_path__ + "d5fd23e9ed7fcc4b3e57b85f7d7f53b1.png";